<template>
  <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper">
    <div class="row">
      <div class="col-sm-6 text-left">
        <div class="form-group text-left">
            <div class="btn btn-default btn-table-title" @click="toggleModal('cr')">新增綁定</div>
        </div>
        <div class="form-group">
          <select class="form-control h-38" v-model="managerSelect" @change="getNewList(managerSelect)">
            <option value="99">此帳號管理者</option>
            <option v-for="manager in managerList" :value="manager.manager_id">
              {{manager.name}}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 table-responsive p-x-0">
        <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
          <thead>
          <tr role="row">
            <th>#</th>
            <th>綁定ID</th>
            <th>通知方式</th>
            <th>系統稱呼 (ID)</th>
            <th>啟用</th>
            <th>更新時間</th>
            <th>建立時間</th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr class="even" role="row" v-for="(notify, index) in notifyList">
            <td class="sorting_1">
              <span>{{index + 1}}</span>
            </td>
            <td>{{notify.notify_id}}</td>
            <td>{{notifyMethodName(notify.notify_method)}}</td>
            <td>{{notify.alias_name}} ({{notify.manager_id}})</td>
            <td>
              <span v-if="notify.toggle" class="label label-success">正常</span>
              <span v-if="!notify.toggle"  class="label label-danger">停用</span>
            </td>
            <td>{{notify.update_time}}</td>
            <td>{{notify.create_time}}</td>
            <td>
              <button class="btn btn-danger" data-toggle="modal" data-target="#delModal"
                      @click="getCurrent(notify.manager_id, notify.alias_name, notify.notify_id, notify.notify_method)"
              ><i class="fa fa-trash" aria-hidden="true"></i></button>
            </td>
            <td>
              <button class="btn btn-default"
                      @click="storeCombine(notify.manager_id)"
              >綁定門市</button>
            </td>
            <td>
              <button class="btn btn-default" data-toggle="modal" data-target="#sendMsgModal"
                      @click="getCurrent(notify.manager_id, notify.alias_name, notify.notify_id, notify.notify_method)">
                <i class="fa fa-comment" aria-hidden="true"></i>
              </button>
            </td>
            <td>
              <button class="btn btn-default" @click="toggleModal('up', notify)"><i class="fa fa-pencil" aria-hidden="true"></i></button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="col-xs-12 text-center">
        <ul class="pagination">
          <li class="paginate_button" v-if="pageAmount > 1 && pageGroup !== 1" @click="pageGroup = pageGroup - 1">
            <a class="c-pointer"><i class="fa fa-angle-double-left" aria-hidden="true"></i></a>
          </li>
          <li class="paginate_button" v-for="index in pageAmount" :class="{active: isActive(index)}" @click="getNotifyBindingList(index)" v-if="pageShow(index)">
            <a class="c-pointer">{{index}}</a>
          </li>
          <li class="paginate_button" v-if="pageAmount > 1 && pageAmount / groupAmount > pageGroup" @click="pageGroup = pageGroup + 1">
            <a class="c-pointer"><i class="fa fa-angle-double-right" aria-hidden="true"></i></a>
          </li>
        </ul>
      </div>
    </div>
    <div class="modal fade" role="dialog" id="addNotifyModal">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">綁定LINE</h4>
          </div>
          <div class="modal-body">
            <div class="box-body form p-x-0">
              <div>
                <br>
                <div class="input-group">
                  <span class="input-group-addon"><span class="text-red">＊ </span>系統稱呼</span>
                  <input class="form-control" placeholder="" type="text" v-model="lineUserName">
                </div>
                <div>
                  <span class="text-red text-15">(目前一組Line帳號只可綁定一組後台帳號)</span>
                </div>
                <!--<div class="input-group" v-if="!show.cr">-->
                  <!--<span class="input-group-addon"><span class="text-red">＊ </span>綁定ID</span>-->
                  <!--<input class="form-control" placeholder="" type="text" v-model="lineUserId">-->
                <!--</div>-->
                <br>
                <div class="input-group" v-if="!show.cr">
                  <span class="input-group-addon"><span class="text-red">＊ </span>啟用</span>
                    <select class="form-control" v-model="toggleSelect">
                      <option value="1">啟用</option>
                      <option value="0">停用</option>
                    </select>
                  <br>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">取消</button>
            <button type="button" class="btn btn-success" @click="checkInput('cr')" v-if="show.cr">新增</button>
            <button type="button" class="btn btn-success" @click="checkInput('up')" v-if="!show.cr">修改</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" role="dialog" id="addStoreNotifyModal">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">門市綁定</h4>
          </div>
          <div class="modal-body">
            <div class="box-body form p-x-0">
              <div>
                <div class="input-group" v-show="show.cr">
                  <span class="input-group-addon"><span class="text-red">＊ </span>品牌</span>
                  <select class="form-control h-38" v-model="binding.brandSelect">
                    <option v-for="brand in binding.brandBrief" :value="brand.value">
                      {{brand.label}}
                    </option>
                  </select>
                  <br>
                </div>
                <span v-show="show.cr"><span class="hidden-xs hidden-sm"><br></span><br></span>
                <div class="input-group" v-show="show.cr">
                  <span class="input-group-addon"><span class="text-red">＊ </span>店家</span>
                  <select class="form-control h-38" v-model="binding.storeSelect">
                    <option v-for="store in binding.storeBrief" :value="store.value">
                      {{store.label}}
                    </option>
                  </select>
                  <br>
                </div>
                <!--<span v-show="show.cr"><span class="hidden-xs hidden-sm"><br></span><br></span>-->
                <!--<div class="input-group">-->
                  <!--<span class="input-group-addon"><span class="text-red">＊ </span>綁定方式</span>-->
                  <!--<select class="form-control h-38" v-model="binding.methodSelect">-->
                    <!--&lt;!&ndash;<option value="41">LineLogin</option>&ndash;&gt;-->
                    <!--<option value="42">LineNotify</option>-->
                  <!--</select>-->
                  <!--<br>-->
                <!--</div>-->
                <span><span class="hidden-xs hidden-sm"><br></span><br></span>
                <div class="input-group" v-if="!show.cr">
                  <span class="input-group-addon"><span class="text-red">＊ </span>啟用</span>
                  <select class="form-control" v-model="toggleSelect">
                    <option value="1">啟用</option>
                    <option value="0">停用</option>
                  </select>
                  <br>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">取消</button>
            <button type="button" class="btn btn-success" @click="crStoreCombine" v-if="show.cr">新增</button>
          </div>
        </div>
      </div>
    </div>
    <m-modal :option="delOption" @trigger="trigger"></m-modal>
    <m-modal :option="sendMsgOption" @trigger="trigger" @inputOnChange="inputOnChange"></m-modal>
  </div>
</template>
<script>
import $ from 'jquery'
import { mapGetters, mapActions } from 'vuex'
import matcherModal from '../../../elements/Modal.vue'

export default{
  components: {
    'm-modal': matcherModal
  },
  data () {
    return {
      count: 10,
      notifyList: [],
      show: {
        brand: false,
        menu: false,
        schedule: false,
        cr: true
      },
      type: '',
      selectRoleType: '',
      total: {},
      maxTotal: 0,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      delOption: {
        id: 'delModal',
        title: '刪除綁定',
        body: '',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'delManager'
          }
        ]
      },
      sendMsgOption: {
        id: 'sendMsgModal',
        title: '發送訊息',
        body: '確定發送通知訊息給此使用者？',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'sendMsg'
          }
        ],
        input: {
          name: '訊息內容'
        }
      },
      lineUserId: '',
      lineUserName: '',
      toggleSelect: 1,
      managerId: '',
      current: {
        notify_ids: 0,
        manager_id: 0,
        name: ''
      },
      brandBrief: [],
      storeBrief: [],
      managerList: [],
      managerSelect: 99,
      selectManagerId: 99,
      // bindingModal
      binding: {
        brandSelect: 99,
        storeSelect: 99,
        methodSelect: 42,
        toggleSelect: 1,
        brandBrief: [],
        storeBrief: [],
        managerId: 0
      },
      send: {
        msg: '',
        notify_method: 42
      }
    }
  },
  methods: {
    ...mapActions(['setSelManagerId', 'setSelRoleType']),
    trigger (event) {
      if (event === 'delManager') {
        this.delBinding()
      } else if (event === 'sendMsg') {
        this.sendMsg()
      }
    },
    delBinding () {
      var self = this
      var url = '/manager/' + self.selectRoleType + '/' + self.current.manager_id + '/notifyBinding?notify_ids=' + self.current.notify_ids
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.getNotifyBindingList(1)
        }
      })
    },
    showSelect (type) {
      if (this.selectRoleType === 'all') return true
      else {
        if (this.selectRoleType === type) return true
        else return false
      }
    },
    getNotifyBindingList (index) {
      this.tableIndex = index
      this.notifyList = []
      var self = this
      const data = {
        page: this.tableIndex,
        count: this.count
      }
      var url = '/manager/' + self.selectRoleType + '/' + self.selectManagerId + '/notifyBinding/list?page=' + data.page + '&size=' + data.count
      this.getDataH('get', url, data, function (response) {
        if (response.data.status === 200) {
          self.notifyList = response.data.notify_list
          self.maxTotal = response.data.total
        }
      })
    },
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    },
    isType (type) {
      if (this.selectRoleType === type) return true
      else return false
    },
    roleName (type) {
      if (type === 'admin') {
        return '系統'
      } else if (type === 'brand') {
        return '品牌'
      } else if (type === 'store') {
        return '店家'
      }
    },
    notifyMethodName (type) {
      if (type === 41) {
        return 'LineLogin'
      } else if (type === 42) {
        return 'LineNotify'
      }
    },
    getCurrent (managerId, name, notifyId, notifyMethod) {
      this.current.manager_id = managerId
      this.current.name = name
      this.current.notify_ids = notifyId
      this.send.notify_method = notifyMethod
      this.delOption.body = '確定刪除 ' + name + ' ?<br>刪除此綁定，將無法收到通知！'
    },
    pageShow (index) {
      var num = index / this.groupAmount
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true
      else return false
    },
    bindLineId () {
      let data = {
        manager_id: this.getUserId,
        mc_token: this.getToken,
        unique_key: '',
        alias_name: this.lineUserName
      }
      let dataJson = JSON.stringify(data)
      let url = 'https://notify-bot.line.me/oauth/authorize?'
      url += 'response_type=code'
      url += '&client_id=wG3GONbq22mKz06g1kyIF0'
      url += '&redirect_uri=' + this.$config.baseURL + '/manager/lineNotifyCallback'
      url += '&scope=notify'
      url += '&state=' + encodeURI(dataJson)
      window.location.href = url
    },
    toggleModal (type, notify) {
      $('#addNotifyModal').modal('toggle')
      this.lineUserId = ''
      this.lineUserName = ''
      this.toggleSelect = 1
      this.managerId = ''
      if (type === 'cr') this.show.cr = true
      else {
        this.lineUserId = notify.notify_id
        this.managerId = notify.manager_id
        this.lineUserName = notify.alias_name
        this.toggleSelect = notify.toggle
        this.show.cr = false
      }
    },
    checkInput (type) {
      if (!this.lineUserName) {
        this.$notify({
          title: '提醒',
          text: '請輸入管理者名稱',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else {
        if (type === 'cr') {
          $('#addNotifyModal').modal('toggle')
          this.bindLineId()
        } else this.updateLineId()
      }
    },
    updateLineId () {
      var self = this
      const data = {
        notify_id: this.lineUserId,
        alias_name: this.lineUserName,
        toggle: this.toggleSelect
      }
      var url = '/manager/' + self.selectRoleType + '/' + self.managerId + '/notifyBinding'
      this.getDataH('put', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          $('#addNotifyModal').modal('toggle')
          self.getNotifyBindingList(1)
        }
      })
    },
    storeCombine (managerId) {
      $('#addStoreNotifyModal').modal('toggle')
      this.binding.toggleSelect = 1
      this.binding.managerId = managerId
      this.show.cr = true
    },
    crStoreCombine () {
      var self = this
      var url = '/store/' + this.binding.storeSelect + '/notifyBinding'
      let data = {
        notify_method: this.binding.methodSelect,
        manager_id: this.binding.managerId
      }
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          $('#addStoreNotifyModal').modal('toggle')
        }
      })
    },
    getBrandBrief () {
      var self = this
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list
          for (let i = 0; i < bList.length; i++) {
            let obj = {label: bList[i].name, value: bList[i].brand_id}
            self.brandBrief.push(obj)
            self.binding.brandBrief.push(obj)
            if (i === 0) self.binding.brandSelect = obj.value
          }
        }
      })
    },
    getStoreBrief (brandId, method) {
      if (!method) this.storeBrief = []
      this.binding.storeBrief = []
      var self = this
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list
          for (let i = 0; i < sList.length; i++) {
            let obj = {label: sList[i].name, value: sList[i].store_id}
            if (!method) {
              self.storeBrief.push(obj)
              self.binding.storeBrief.push(obj)
            } else self.binding.storeBrief.push(obj)
            if (i === 0) self.binding.storeSelect = obj.value
          }
        }
      })
    },
    inputOnChange (value) {
      this.send.msg = value
    },
    sendMsg () {
      var self = this
      var data = {
        notify_method: this.send.notify_method,
        message: this.send.msg
      }
      var url = '/manager/' + this.selectRoleType + '/' + this.current.manager_id + '/sendNotify'
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
        }
      })
    },
    getSubordinate () {
      var self = this
      var url = '/manager/' + this.selectRoleType + '/' + this.selectManagerId + '/subordinate'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.managerList = []
          var mList = response.data.subordinate.manager_list
          for (var i = 0; i < mList.length; i++) {
            if (mList[i].manager_id !== parseInt(self.getUserId, 10)) self.managerList.push(mList[i])
          }
        }
      })
    },
    getNewList (managerId) {
      var list = this.managerList.find(function (o) {
        return o.manager_id === parseInt(managerId, 10)
      })
      if (!list) {
        list = {
          manager_id: this.getUserId,
          name: '',
          role_type: parseInt(this.getRoleType, 10)
        }
      }
      if (list.role_type === 99) this.selectRoleType = 'admin'
      else if (list.role_type === 50) this.selectRoleType = 'pos'
      else if (list.role_type === 30) this.selectRoleType = 'brand'
      else if (list.role_type === 10) this.selectRoleType = 'store'
      this.selectManagerId = list.manager_id
    }
  },
  computed: {
    ...mapGetters(['getRoleType', 'getUserId', 'getToken']),
    getDataH () {
      return this.$parent.getDataH
    },
    pageAmount () {
      return Math.ceil(this.maxTotal / this.count)
    },
    fixedH () {
      return this.$parent.fixedH
    }
  },
  created () {
    this.fixedH()
    var roleType = parseInt(this.getRoleType, 10)
    if (roleType === 99) this.selectRoleType = 'admin'
    else if (roleType === 30) this.selectRoleType = 'brand'
    else if (roleType === 10) this.selectRoleType = 'store'
    this.selectManagerId = this.getUserId
    this.getSubordinate()
    this.getBrandBrief()
  },
  watch: {
    'binding.brandSelect' () {
      this.getStoreBrief(this.binding.brandSelect, 'modal')
    },
    selectManagerId () {
      this.getNotifyBindingList(1)
      const managerId = this.selectManagerId
      const roleType = this.selectRoleType
      this.setSelManagerId(managerId)
      this.setSelRoleType(roleType)
    }
  }
}
</script>



// WEBPACK FOOTER //
// LineNotifyTableTemp.vue?66413df6